import { TransformPlainObject } from './transform.plainObject';

export class FilterPlainObject extends TransformPlainObject {
    public conditionExpression: string;
}
